import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import TicketCard from './TicketCard';
import { useLayout } from '../../../../context/LayoutContext';

const TicketColumn = ({ departmentId, section, tickets }) => {
  const { theme } = useLayout();
  const { id, name, icon } = section;

  return (
    <div className={`GM__${theme}-ticket-column`}>
      <div className={`GM__${theme}-column-header`}>
        <div className={`GM__${theme}-column-icon`}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {icon === 'alert-triangle' && <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>}
            {icon === 'clock' && <circle cx="12" cy="12" r="10"></circle>}
            {icon === 'flask' && <path d="M9 3h6v2H9zM9 5v11a3 3 0 0 0 6 0V5"></path>}
            {icon === 'check-circle' && <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>}
            {icon === 'refresh-cw' && <path d="M21 2v6h-6"></path>}
          </svg>
        </div>
        <h2 className={`GM__${theme}-column-title`}>
          {name} <span className={`GM__${theme}-column-count`}>({tickets.length})</span>
        </h2>
        <button className={`GM__${theme}-add-column-ticket-btn`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>

      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <div
            className={`GM__${theme}-column-content ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {tickets.length === 0 ? (
              <div className={`GM__${theme}-empty-column`}>
                <p>No hay tickets en esta sección</p>
              </div>
            ) : (
              tickets.map((ticket, index) => (
                <TicketCard 
                  key={ticket.id} 
                  ticket={ticket} 
                  index={index} 
                />
              ))
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default TicketColumn;